import { useEffect } from 'react'

interface Props {
  title?: string
}

export const usePageTitle = (props: Props) => {
  const { title } = props

  useEffect(() => {
    if (!title) return

    const newTitle = `${title} - Mate Line`
    document.title = newTitle
  }, [title])
}
